import React, { useEffect, useState } from 'react';
import { Button, message, Space, Table } from 'antd';
import { Adminauthcontexthooks } from '../../Hooks/Adminauthcontexthooks';


const Vclinkstable = () => {
    const columns = [
        {
            title: 'Name',
            dataIndex: 'Personname',
            key: 'Personname',
            render: text => <p>{text}</p>,
        },
        {
            title: 'Room no.',
            dataIndex: 'roomno',
            key: 'roomno',
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
        },
        {
            title: 'Staff name',
            dataIndex: 'staffname',
            key: 'staffname',
        },
        {
            title: 'Mobile no.',
            dataIndex: 'mobileno',
            key: 'mobileno',
        },
        {
            title: 'Email id',
            dataIndex: 'emailid',
            key: 'emailid',
        },
        {
            title: 'Court name',
            dataIndex: 'selectcourt',
            key: 'selectcourt',
        },
        {
            title: 'Sub District Court',
            dataIndex: 'selectsubdistcourt',
            key: 'selectsubdistcourt',
        },
        {
            title: 'District',
            dataIndex: 'selectdist',
            key: 'selectdist',
        },
        {
            title: 'Links',
            dataIndex: 'vclinks',
            key: 'vclinks',
            render: text => <a
                href={text}
                target="_blank"
                rel="noopener noreferrer"
            >
                Link
            </a>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_id, record) => (
                <Space size="middle">
                    <Button color="red" variant="dashed" loading={subbtnloading} onClick={() => Delvclink(_id)} disabled={subbtnloading}>Delete</Button>
                </Space>
            ),
        },
    ];
    const { user } = Adminauthcontexthooks();
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);
    const [subbtnloading, setsubbtnloading] = useState(false);

    const GetVcLinks = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/vclinks', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
        const data = await res.json();
        if (res.status === 200) {
            setdata(data.VclinksOBJ);
            setloading(false);
        }
    }

    const Delvclink = async (obj) => {
        const id = obj._id
        setsubbtnloading(true);
        const res = await fetch(`https://cdr-backend.onrender.com/delete/vclinks/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }
        });
        //const data = await res.json();
        if (res.status === 200) {
            message.success("VC Link deleted successfully");
            setsubbtnloading(false);
            GetVcLinks();
            return;
        } else {
            message.error("Something went wrong");
            setsubbtnloading(false);
            return;
        }
    }

    useEffect(() => {
        if (user) {
            const GetVcLinks = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/vclinks', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }

                });
                const data = await res.json();
                if (res.status === 200) {
                    setdata(data.VclinksOBJ);
                    setloading(false);
                }
            }
            GetVcLinks()
        }
    }, [data, user])
    return (
        <>
            <Table columns={columns} dataSource={data} loading={loading} size='small'/>
        </>
    )
}

export default Vclinkstable;